import React from "react";
import {
  CommonMFE,
  MFE_NAMES,
  ReactMFE,
} from "@tpd-web-common-libs/nodejs-library";
import { ContainerDiv } from "./App.style";
import styled from "@emotion/styled";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { ListItem } from "./list-item/ListItem";
import classNames from "classnames";

const App = (props: CommonMFE.Types.TRemoteProps) => {
  const { __host__, config, menu, isEditMode, id: containerID } = props;

  const tpdShortText = config["Titolo"];
  const voceMenu = config["Voce_menu"].value.value;
  const aChiSiRivolge = voceMenu?.toLowerCase();

  return (
    <ContainerDiv
      id={voceMenu}
      className="menu-vc-section"
      titolo={tpdShortText.value.value}
    >
      <div
        className={`tpd-a-chi-si-rivolge-title ${
          aChiSiRivolge !== "a chi si rivolge" ? "tpd-pt-0" : ""
        }`}
      >
        <h2
          className={classNames("tpd-short-text", {
            blue:
              __host__.pageProperties.colorClassDesktop &&
              __host__.pageProperties.colorClassDesktop !== "",
          })}
        >
          <ReactMFE.Remote
            id={CommonMFE.generateID(
              containerID,
              `${MFE_NAMES.tpdAChiSiRivolgeTitle}-Titolo`
            )}
            __deps__={React}
            __host__={__host__}
            __mfeName__={MFE_NAMES.tpdShortText}
            isEditMode={isEditMode}
            {...tpdShortText}
          />
        </h2>
        <div className="tpd-list">
          <ReactMFE.List
            __deps__={React}
            __host__={__host__}
            isEditMode={isEditMode}
            list={menu.itemsMenu}
            ListItemComponent={ListItem}
            showSortingOption= {true}
          />
        </div>
      </div>
    </ContainerDiv>
  );
};

export default ReactMFE.PrimaryRemoteHOCFactory(
  React,
  styled,
  { CacheProvider },
  createCache
)(App);
